export default __webpack_public_path__ + "static/media/3.73cfe724.jpeg";